import { httpInstance } from '@/services/httpInstance';

const createRemittanceService = async (dataParam) => {
  let res;
  const endpoint = '/back-office/v1/remittances';
  const dataSent = dataParam;

  await httpInstance.post(
    endpoint,
    dataSent,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default createRemittanceService;
